<div class="checkout-page">
  <div class="thankyou-page">
    <h2>Thank you for Shopping with us!</h2>
    <h3>
      We have received your order and it will be delivered within the next 3-5
      working days
    </h3>
    <button type="button" class="btn btn-primary" routerLink="/">
      Back to shop
    </button>
  </div>
</div>
